import React from 'react';
import './SkuBarcodeModal.css';

const CODE128_PATTERNS = [
  '212222', '222122', '222221', '121223', '121322', '131222', '122213', '122312', '132212',
  '221213', '221312', '231212', '112232', '122132', '122231', '113222', '123122', '123221',
  '223211', '221132', '221231', '213212', '223112', '312131', '311222', '321122', '321221',
  '312212', '322112', '322211', '212123', '212321', '232121', '111323', '131123', '131321',
  '112313', '132113', '132311', '211313', '231113', '231311', '112133', '112331', '132131',
  '113123', '113321', '133121', '313121', '211331', '231131', '213113', '213311', '213131',
  '311123', '311321', '331121', '312113', '312311', '332111', '314111', '221411', '431111',
  '111224', '111422', '121124', '121421', '141122', '141221', '112214', '112412', '122114',
  '122411', '142112', '142211', '241211', '221114', '413111', '241112', '134111', '111242',
  '121142', '121241', '114212', '124112', '124211', '411212', '421112', '421211', '212141',
  '214121', '412121', '111143', '111341', '131141', '114113', '114311', '411113', '411311',
  '113141', '114131', '311141', '411131', '211412', '211214', '211232', '2331112',
];

export const encodeCode128B = (value) => {
  const raw = String(value || '').trim();
  const sanitized = raw.replace(/[^\x20-\x7f]/g, '?');
  if (!sanitized) return { modules: [], text: '' };

  const codes = [104];
  for (const char of sanitized) {
    codes.push(char.charCodeAt(0) - 32);
  }

  const checksum = codes.reduce((sum, code, index) => (
    index === 0 ? sum + code : sum + code * index
  ), 0) % 103;
  codes.push(checksum, 106);

  const modules = [];
  codes.forEach((code) => {
    const pattern = CODE128_PATTERNS[code] || '';
    for (let i = 0; i < pattern.length; i += 1) {
      modules.push({
        width: Number(pattern[i]) || 1,
        black: i % 2 === 0,
      });
    }
  });

  return { modules, text: sanitized };
};

export const normalizeSkuForBarcode = (value) => {
  const sku = String(value || '').trim();
  if (!sku) return '';
  const idx = sku.indexOf('-');
  return idx > 0 ? sku.slice(0, idx).trim() : sku;
};

const SkuBarcodeModal = ({ sku, onClose }) => {
  if (!sku) return null;
  const { modules, text } = encodeCode128B(sku);
  const quietZone = 10;
  const barHeight = 120;
  const contentWidth = modules.reduce((sum, module) => sum + module.width, 0);
  const totalWidth = contentWidth + quietZone * 2;
  let x = quietZone;

  return (
    <div className="sku-code-overlay" role="dialog" aria-modal="true" aria-label="SKU barcode">
      <div className="sku-code-card">
        <button type="button" className="sku-code-close" onClick={onClose} aria-label="Close barcode">
          ×
        </button>
        <div className="sku-code-title">Scan SKU</div>
        <svg
          className="sku-code-svg"
          viewBox={`0 0 ${totalWidth} ${barHeight}`}
          role="img"
          aria-label={`Barcode for SKU ${text}`}
          preserveAspectRatio="none"
        >
          <rect x="0" y="0" width={totalWidth} height={barHeight} fill="#ffffff" />
          {modules.map((module, index) => {
            const rect = module.black ? (
              <rect
                key={`${index}-${x}`}
                x={x}
                y="0"
                width={module.width}
                height={barHeight}
                fill="#000000"
              />
            ) : null;
            x += module.width;
            return rect;
          })}
        </svg>
        <div className="sku-code-value">{text}</div>
      </div>
    </div>
  );
};

export default SkuBarcodeModal;
